import { ACDLRoute, BaseRouteConfig } from './BaseRoute';

class AuthConfig extends BaseRouteConfig {
  public readonly Index = '';

  public readonly Login = new ACDLRoute(`${this.Path}/login`);
  public readonly Register = new ACDLRoute(`${this.Path}/register`);
  public readonly ForgotPassword = new ACDLRoute(`${this.Path}/forgotpassword`);
  public readonly ResendConfirmationEmail = new ACDLRoute(`${this.Path}/resendConfirmationEmail`);
  public readonly ConfirmEmail = new ACDLRoute(`${this.Path}/confirmEmail`);
  public readonly ConfirmNewEmail = new ACDLRoute(`${this.Path}/confirmEmailChange`);
  public readonly ResetPassword = new ACDLRoute<{ token: string }>(`${this.Path}/resetpassword/:token`);
}

export const Auth = new AuthConfig('');
